const productActionType = {
  // products
  FETCH_PRODUCTS: "FETCH_PRODUCTS",
  FETCH_PRODUCTS_SUCCESS: "FETCH_PRODUCTS_SUCCESS",
  FETCH_PRODUCTS_FAILURE: "FETCH_PRODUCTS_FAILURE",
  // search
  CLEAR_SEARCH: "CLEAR_SEARCH",
  // save product filters to store
  SAVE_PRODUCT_FILTERS: "SAVE_PRODUCT_FILTERS",
  // remove/update - products/variants in filtered products
  REMOVE_VARIANTS_IN_FILTERED_PRODUCTS: "REMOVE_VARIANTS_IN_FILTERED_PRODUCTS",
  REMOVE_ALL_FILTERED_PRODUCTS: "REMOVE_ALL_FILTERED_PRODUCTS",
  UPDATE_FILTERED_PRODUCTS: "UPDATE_FILTERED_PRODUCTS",

  // find product
  FIND_PRODUCT: "FIND_PRODUCT",
  FIND_PRODUCT_SUCCESS: "FIND_PRODUCT_SUCCESS",
  FIND_PRODUCT_FAILURE: "FIND_PRODUCT_FAILURE",

  // delete product
  DELETE_PRODUCT: "DELETE_PRODUCT",
  DELETE_PRODUCT_SUCCESS: "DELETE_PRODUCT_SUCCESS",
  DELETE_PRODUCT_FAILURE: "DELETE_PRODUCT_FAILURE",
  // update variant customer experience
  UPDATE_VARIANT_CUSTOMER_EXPERIENCE_SUCCESS: "UPDATE_VARIANT_CUSTOMER_EXPERIENCE_SUCCESS",
  UPDATE_VARIANT_CUSTOMER_EXPERIENCE_FAILURE: "UPDATE_VARIANT_CUSTOMER_EXPERIENCE_FAILURE",

  // operation progress
  START_OPERATION: "START_OPERATION",
  UPDATE_OPERATION_PROGRESS: "UPDATE_OPERATION_PROGRESS",
  COMPLETE_OPERATION: "COMPLETE_OPERATION",

  // CSV uploads
  FETCH_CSV_UPLOADS: "FETCH_CSV_UPLOADS",
  FETCH_CSV_UPLOADS_SUCCESS: "FETCH_CSV_UPLOADS_SUCCESS",
  FETCH_CSV_UPLOADS_FAILURE: "FETCH_CSV_UPLOADS_FAILURE",
  UPLOAD_CSV: "UPLOAD_CSV",
  UPLOAD_CSV_SUCCESS: "UPLOAD_CSV_SUCCESS",
  UPLOAD_CSV_FAILURE: "UPLOAD_CSV_FAILURE",
};

export default productActionType;
